var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtitles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 1.6c.4 0 .8.2 1.1.5.3.3.5.7.5 1.1v9.6c0 .4-.2.8-.5 1.1-.3.3-.7.5-1.1.5H1.6c-.4 0-.8-.2-1.1-.5s-.5-.7-.5-1.1V3.2c0-.4.2-.8.5-1.1s.7-.5 1.1-.5h12.8zM1.6 8v1.6h3.2V8H1.6zm8 4.8v-1.6h-8v1.6h8zm4.8-3.2V8h-8v1.6h8zm0 3.2v-1.6h-3.2v1.6h3.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitles);
export default __webpack_public_path__ + "static/media/subtitles.e5e9108e5e9096871b12663170a3003e.svg";
export { ForwardRef as ReactComponent };